module.exports = __webpack_public_path__ + "media/images/sample-pdf-doc-f9eef90dd56414044caf182366e2299a.png";